var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-shadow */
import { useEffect, useState } from 'react';
const msg = (text) => `[useProductData] ${text.join('')}`;
// eslint-disable-next-line import/prefer-default-export
export function useProductData({ userId, accountId, apiToken, hostname, refetchLimit = 5, loggerImpl = console, fetchImpl = fetch }) {
    const [result, setResult] = useState();
    const defaultResult = {
        data: {
            subscriptionGroups: [],
            globalNavigation: []
        },
        error: undefined
    };
    useEffect(() => {
        if (!userId && !isJWT(apiToken)) {
            loggerImpl.error(msg `userId is required for PAM API tokens`);
            setResult(Object.assign(Object.assign({}, defaultResult), { error: { code: 'MISSING_USER_ID' } }));
            return;
        }
        if (!accountId) {
            loggerImpl.error(msg `accountId is required`);
            setResult(Object.assign(Object.assign({}, defaultResult), { error: { code: 'MISSING_ACCOUNT_ID' } }));
            return;
        }
        if (!apiToken) {
            loggerImpl.error(msg `apiToken is required`);
            setResult(Object.assign(Object.assign({}, defaultResult), { error: { code: 'MISSING_API_TOKEN' } }));
            return;
        }
        if (!hostname) {
            loggerImpl.error(msg `hostname is required`);
            setResult(Object.assign(Object.assign({}, defaultResult), { error: { code: 'MISSING_HOSTNAME' } }));
            return;
        }
        fetchData(userId, accountId, refetchLimit);
    }, [accountId, userId, apiToken, hostname]);
    const fetchData = (userId, accountId, refetchLimit, refetchCount = 0) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const params = new URLSearchParams({
            userId,
            accountId
            // TODO: use 'satisfies' instead of 'as' when TS is updated
        });
        try {
            loggerImpl.info({ userId, accountId }, msg `Fetching product data`);
            const response = yield fetchImpl(`${hostname}/product-data?${params.toString()}`, {
                method: 'get',
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${apiToken}`
                }
            });
            const json = (yield response.json());
            loggerImpl.info({ json }, msg `Received product data`);
            // schedule refetch if the first value data is still pending
            if (((_a = json === null || json === void 0 ? void 0 : json.error) === null || _a === void 0 ? void 0 : _a.code) === 'FIRST_VALUE_PENDING' && refetchCount < refetchLimit) {
                loggerImpl.info({ userId, accountId, refetchCount, refetchLimit }, msg `Scheduling refetch`);
                setTimeout(() => {
                    loggerImpl.info({ userId, accountId, refetchCount, refetchLimit }, msg `Firing refetch`);
                    fetchData(userId, accountId, refetchLimit, refetchCount + 1);
                }, 30 * 1000); // 30 seconds
            }
            setResult(json);
        }
        catch (error) {
            loggerImpl.error({ error }, msg `Fetching product data failed.`);
            // TODO: use 'satisfies' instead of 'as' when TS is updated
            setResult({ error: { code: 'API_FETCH_FAILED' } });
        }
    });
    return Object.assign(Object.assign({}, defaultResult), (result ? postProcessSubscriptionGroups(result) : result));
}
function isJWT(token) {
    return token.split('.').length === 3;
}
export function postProcessSubscriptionGroups(input) {
    var _a;
    if ((_a = input === null || input === void 0 ? void 0 : input.data) === null || _a === void 0 ? void 0 : _a.subscriptionGroups) {
        input.data.subscriptionGroups = input.data.subscriptionGroups
            // remove subscriptions without showInNavigation flag
            .map(group => (Object.assign(Object.assign({}, group), { subscriptions: group.subscriptions.filter(sub => sub.product.uxOptions.showInNavigation) })))
            // remove any now-empty subscriptionGroups
            .filter(group => group.subscriptions.length > 0);
    }
    return input;
}
//# sourceMappingURL=useProductData.js.map